import { render, staticRenderFns } from "./ButtonEvaluate.vue?vue&type=template&id=5fcb0014"
import script from "./ButtonEvaluate.vue?vue&type=script&lang=js"
export * from "./ButtonEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports